<template>
    <VJoyWrapper direction="column" align="stretch" row-gap="4" no-margin>
        <VJoyLabel :text="t('profile.section.header.edit.rqth.title')">
            <template v-if="!activated" #label-legend>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <span data-testid="edit-header-rqth-pending-information" v-html="pendingExplanation" />
            </template>
        </VJoyLabel>
        <VJoyToggle v-model="displayEnabled" :disabled="!activated" class="edit-rqth__toggle" data-testid="edit-header-rqth-toggle">
            {{ t('profile.section.header.edit.rqth.toggle.label') }}
        </VJoyToggle>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyLabel, VJoyToggle, VJoyWrapper} from '@maltjoy/core-vue';

    defineProps<{
        activated: boolean;
    }>();

    const displayEnabled = defineModel<boolean>('displayEnabled', {required: true});

    const {t} = useTranslation();

    // Lands on the freelancer's company settings hub (Traefik-routed to compliance-front); profile-front doesn't
    // have the freelancer's companyId available to deep-link straight to the Legal Documents tab.
    const legalDocumentsLink = '/company';

    const pendingExplanation = computed(() => t('profile.section.header.edit.rqth.pending.explanation', {0: legalDocumentsLink}));
</script>

<style scoped lang="scss">
    .edit-rqth__toggle {
        margin-bottom: var(--joy-core-spacing-2);
    }
</style>
